import { DataColumns } from '../DataColumns/DataColumns';
import GridFlag from '../../../../Core/Components/GridFlag/GridFlag';
import {
  TenantFilterCell,
  GridDateCell,
  BooleanValuesFilterCell,
} from '../../../../Core/Components/Filter/FilterElements';
import { MultiViewCalenderFilterCell } from 'smart-react';

/**
 * Generates a list of columns for a grid.
 * @param {object} options - The options for the grid.
 * @returns {Array} - The list of grid columns.
 */
export const GridColumnsList = async ({
  editScreen,
  dateRangefilter,
  setDateRangeFilter,
}) => {
  return DataColumns({
    editScreen,
    TenantFilterCell,
    MultiViewCalenderFilterCell,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
    GridFlag,
    BooleanValuesFilterCell,
  });
};

export default GridColumnsList;
